import type { ProductId, Wishlist } from '@sshop/domain';

import { parseDto } from '../../mappers/parseDto';
import type { Transport } from '../../transport/Transport';

import type { WishlistService } from './WishlistService';
import { wishlistDto } from './wishlist.dto';
import { toWishlist } from './wishlist.mapper';

export function createLaravelWishlistService(transport: Transport): WishlistService {
  const parse = (raw: unknown, context: string) => toWishlist(parseDto(wishlistDto, raw, context));

  return {
    async get(signal): Promise<Wishlist> {
      const res = await transport.request({
        method: 'GET',
        path: '/wishlist',
        ...(signal !== undefined ? { signal } : {}),
      });
      return parse(res.data, 'GET /wishlist');
    },

    async addItem(productId: ProductId, signal): Promise<Wishlist> {
      const res = await transport.request({
        method: 'POST',
        path: '/wishlist/items',
        body: { product_id: productId },
        ...(signal !== undefined ? { signal } : {}),
      });
      return parse(res.data, 'POST /wishlist/items');
    },

    async removeItem(productId: ProductId, signal): Promise<Wishlist> {
      const res = await transport.request({
        method: 'DELETE',
        path: `/wishlist/items/${encodeURIComponent(productId)}`,
        ...(signal !== undefined ? { signal } : {}),
      });
      return parse(res.data, `DELETE /wishlist/items/${productId}`);
    },

    async addCollection(slug, signal): Promise<Wishlist> {
      const res = await transport.request({
        method: 'POST',
        path: '/wishlist/collections',
        body: { collection_slug: slug },
        ...(signal !== undefined ? { signal } : {}),
      });
      return parse(res.data, 'POST /wishlist/collections');
    },

    async removeCollection(slug, signal): Promise<Wishlist> {
      const res = await transport.request({
        method: 'DELETE',
        path: `/wishlist/collections/${encodeURIComponent(slug)}`,
        ...(signal !== undefined ? { signal } : {}),
      });
      return parse(res.data, 'DELETE /wishlist/collections');
    },

    async clear(signal): Promise<Wishlist> {
      const res = await transport.request({
        method: 'DELETE',
        path: '/wishlist',
        ...(signal !== undefined ? { signal } : {}),
      });
      return parse(res.data, 'DELETE /wishlist');
    },
  };
}
